webpackJsonp([43],{

/***/ 134:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api___ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mutations__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_report__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_provider__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_main__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_admin_tools__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_user__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_chart__ = __webpack_require__(428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_partner__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__casl_ability__ = __webpack_require__(87);










//Vuex modules








__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */]);


function subjectName(item) {
  if (!item || typeof item === "string") {
    return item;
  }

  return item.__type;
}
var defaultAbility = __WEBPACK_IMPORTED_MODULE_16__casl_ability__["a" /* AbilityBuilder */].define({ subjectName: subjectName }, function (can, cannot) {
  can("read", "login");
  cannot(["create", "read", "update", "delete"], "all");
});

var state = {
  loading: false,
  requests: 0,
  login: "",
  authenticated: false,
  tokenExpire: null,
  token: "",
  userGuid: "",
  role: "",
  error: {},
  permissions: [],
  abilities: defaultAbility.rules,
  degaultRules: defaultAbility.rules,
  onlineStaff: [],
  transactionsQueue: []
};
var store;
/* harmony default export */ __webpack_exports__["a"] = (store = new __WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_7__actions__,
  mutations: __WEBPACK_IMPORTED_MODULE_8__mutations__,
  state: state,
  getters: {
    loading: function loading(state) {
      return !!state.loading;
    }
  },
  modules: { report: __WEBPACK_IMPORTED_MODULE_9__modules_report__["a" /* default */], main: __WEBPACK_IMPORTED_MODULE_11__modules_main__["a" /* default */], provider: __WEBPACK_IMPORTED_MODULE_10__modules_provider__["a" /* default */], adminTools: __WEBPACK_IMPORTED_MODULE_12__modules_admin_tools__["a" /* default */], user: __WEBPACK_IMPORTED_MODULE_13__modules_user__["a" /* default */], chart: __WEBPACK_IMPORTED_MODULE_14__modules_chart__["a" /* default */], partner: __WEBPACK_IMPORTED_MODULE_15__modules_partner__["a" /* default */] },
  plugins: [__WEBPACK_IMPORTED_MODULE_5_vuex_dist_logger___default()(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_vuex_persistedstate__["a" /* default */])({ key: "v1.1.11", paths: [] }), function (store) {
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].on("logout", function () {
      store.dispatch("logout");
    });
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].on("loading", function () {
      store.commit("setLoading", true);
    });
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].on("loaded", function () {
      store.commit("setLoading", false);
    });
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].on("message", function (event) {
      try {
        var data = JSON.parse(event.data);
        store.commit(data.type, data.data);
      } catch (err) {
        console.log("Message error ", event);
      }
    });
    setInterval(__WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].health.bind(__WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */]), 10000);
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].on("error", function (err) {
      console.log("api.on(error)", err);
      store.commit("setError", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        statusCode: err.status
      }, err.data));
    });
    store.subscribe(function (mutation) {
      switch (mutation.type) {
        case "setToken":
          __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].setToken(mutation.payload);
          break;
      }
    });
    __WEBPACK_IMPORTED_MODULE_4__api___["a" /* default */].setToken(store.state.token);
  }]
}));

/***/ }),

/***/ 156:
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),

/***/ 158:
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),

/***/ 159:
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_events__);







__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);

var Api = function () {
  function Api() {
    var _this = this;

    var ee = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new __WEBPACK_IMPORTED_MODULE_5_events__["EventEmitter"]();

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Api);

    this.ee = ee;
    this.url = '/api';
    this.token = '';
    this.ws = null;
    this.requests = [];
    __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.interceptors.push(function (request, next) {
      request.headers.set('Token', _this.getToken());
      next();
    });
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Api, [{
    key: 'error',
    value: function error(err) {
      this.ee.emit('loaded');
      if (err.status == 401) {
        this.ee.emit('logout');
      } else {
        this.ee.emit('error', err);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
    }
  }, {
    key: 'setToken',
    value: function setToken(token) {
      var _this2 = this;

      this.token = token;
      try {
        var url = new URL(document.location);
        url.protocol = url.protocol.replace('http', 'ws');
        url.pathname = '/ws';
        url.hash = '';
        url.search = 'token=' + this.token;
        if (this.token) {
          this.ws = new WebSocket(url);
          this.ws.onmessage = function (event) {
            _this2.ee.emit('message', event);
          };
          this.ws.onclose = function (event) {
            _this2.ee.emit('closed', event);
          };
          this.ws.onopen = function (event) {
            console.log('open event ', event);
          };
          this.ws.onerror = function (event) {
            _this2.ee.emit('error', event);
          };
          console.log(this.ws);
        } else if (this.token == null && this.ws) {
          this.ws.close();
        }
      } catch (e) {
        console.log(e);
      }
    }
  }, {
    key: 'getToken',
    value: function getToken() {
      return this.token;
    }
  }, {
    key: 'health',
    value: function health() {
      if (this.token) {
        __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(this.url + '/health', {}).catch(this.error.bind(this));
      }
    }
  }, {
    key: 'post',
    value: function post(url, body, options) {
      var _this3 = this;

      this.ee.emit('loading');
      var req = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.post(this.url + url, body, options || {});
      this.requests.push(req);
      return req.then(function (result) {
        _this3.ee.emit('loaded');
        return result;
      }).catch(this.error.bind(this));
    }
  }, {
    key: 'put',
    value: function put(url, body, options) {
      var _this4 = this;

      this.ee.emit('loading');
      var req = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.put(this.url + url, body, options || {});
      this.requests.push(req);
      return req.then(function (result) {
        _this4.ee.emit('loaded');
        return result;
      }).catch(this.error.bind(this));
    }
  }, {
    key: 'delete',
    value: function _delete(url, options) {
      var _this5 = this;

      this.ee.emit('loading');
      var req = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.delete(this.url + url, options);
      this.requests.push(req);
      return req.then(function (result) {
        _this5.ee.emit('loaded');
        return result;
      }).catch(this.error.bind(this));
    }
  }, {
    key: 'get',
    value: function get(url, options) {
      var _this6 = this;

      this.ee.emit('loading');
      var req = __WEBPACK_IMPORTED_MODULE_3_vue__["default"].http.get(this.url + url, options || {});
      this.requests.push(req);
      return req.then(function (result) {
        _this6.ee.emit('loaded');
        return result;
      }).catch(this.error.bind(this));
    }
  }, {
    key: 'on',
    value: function on(name, fn) {
      this.ee.on(name, fn);
    }
  }, {
    key: 'off',
    value: function off(name, fn) {
      this.ee.removeListener(name, fn);
    }
  }]);

  return Api;
}();

/* harmony default export */ __webpack_exports__["a"] = ((function () {
  var instance;
  if (!instance) {
    instance = new Api();
  }
  return instance;
})());

/***/ }),

/***/ 379:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__casl_ability__ = __webpack_require__(87);


function subjectName(item) {
  if (!item || typeof item === 'string') {
    return item;
  }

  return item.__type;
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__casl_ability__["a" /* AbilityBuilder */].define({ subjectName: subjectName }, function (can, cannot) {
  can('read', 'login');
  cannot(['create', 'read', 'update', 'delete'], 'all');
}));

/***/ }),

/***/ 380:
/***/ (function(module, exports) {

window.String.prototype.ucFirst = function () {
  var str = this;
  if (str.length) {
    str = str.charAt(0).toUpperCase() + str.slice(1);
  }
  return str;
};

/***/ }),

/***/ 381:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
  methods: {
    pad: function pad(value) {
      return ("000000000" + value).substr(-2);
    },
    dateGenerate: function dateGenerate(days) {
      var d = new Date(Date.now());
      d.setDate(d.getDate() + days);
      var date = d.getFullYear() + "-";
      date += this.pad(d.getMonth() + 1) + "-";
      date += this.pad(d.getDate());
      return date;
    },
    currency: function currency(value, digitsAfterPoint) {
      var formatter = new Intl.NumberFormat("en-US", {
        minimumFractionDigits: digitsAfterPoint,
        maximumFractionDigits: digitsAfterPoint /* this might not be necessary */
      });
      return formatter.format(value);
    },
    newGuid: function newGuid() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0,
            v = c == "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
      });
    }
  }
});
/*import moment from 'moment';
Vue.filter("date", function(value, format){
  if(value) return '';
  if(format) {console.error("Argument format required in filter");return '';}
  return moment(value).format(format);
})*/

/***/ }),

/***/ 383:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(503)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(683),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 410:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__event__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_menu__ = __webpack_require__(416);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app",
  data: function data() {
    return {
      menus: __WEBPACK_IMPORTED_MODULE_4__api_menu__["a" /* default */],
      drawer: true,
      mini: false,
      right: null
    };
  },

  watch: {
    drawer: {
      handler: function handler(val) {
        console.log(val);
      }
    },
    error: function error(val) {
      if (val.statusCode === 403) {
        this.$router.push({ name: "403" });
      }
    },
    abilities: function abilities(val) {
      this.setAbilities(val);
    }
  },
  mounted: function mounted() {
    this.$store.dispatch("checkAuth");
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3__event__["a" /* default */].forEach(function (item) {
      _this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.setAbilities(this.$store.state.abilities);
  },


  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* mapState */])({
    role: "role",
    permissions: "permissions",
    authenticated: "authenticated",
    login: "login",
    error: "error",
    abilities: "abilities"
  }), {
    screenWidth: function screenWidth() {
      return document.documentElement.clientWidth;
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    menuCan: function menuCan(item, group) {
      var _this2 = this;

      var name = item.name,
          component = item.component,
          href = item.href,
          items = item.items;

      var uri = {};
      if (href) {
        uri.to = href;
      } else if (component) {
        uri.name = component;
      } else if (group && name) {
        uri.name = group + "/" + name;
      } else if (name) {
        uri.name = name;
      } else if (item.items) {
        //return false;
        return item.items.map(function (i) {
          return _this2.menuCan(i, item.group);
        }).filter(function (i) {
          return i;
        }).length > 0;
      } else return false;

      var _$router$resolve = this.$router.resolve(uri),
          meta = _$router$resolve.route.meta;

      return meta.hasOwnProperty("can") && (typeof meta.can == "string" ? this.$can("read", meta.can) : meta.can);
    },
    genChildTarget: function genChildTarget(item, subItem) {
      if (subItem.href) return;
      if (subItem.component) {
        return {
          name: subItem.component
        };
      }
      return { name: item.group + "/" + subItem.name };
    },
    setAbilities: function setAbilities(val) {
      this.$ability.update([]);
      this.$ability.update(val);
    }
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])(["logout"]), {
    navigate: function navigate(url) {
      if (url != "" && url != undefined) {
        console.log(url);
        this.$router.push(url);
      }
    }
  })
});

/***/ }),

/***/ 416:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var Menu = [
//   { header: "Apps" },
{
  title: "Dashboard",
  group: "apps",
  icon: "dashboard",
  name: "dashboard"
}, { divider: true }, {
  title: "Agents Info",
  group: "",
  icon: "fa fa-home",
  items: [{
    component: "main/users",
    icon: "fa fa-user",
    title: "Agents Account"
  }, {
    component: "user/kyc",
    icon: "fa fa-user",
    title: "Agent Kyc Requests"
  }, {
    component: "user/kyc-verified",
    icon: "fa fa-user",
    title: "Agent Kyc Verified"
  }, {
    component: "user/kyc-rejected",
    icon: "fa fa-user",
    title: "Agent Kyc Rejected"
  }]
}, {
  icon: "fa fa-tasks",
  title: "Reports",
  group: "report",
  items: [{
    name: "queue",
    icon: "fa fa-tasks",
    title: "Queue"
  }, {
    name: "technical",
    icon: "fa fa-tasks",
    title: "Technical"
  }, {
    name: "financial",
    icon: "fa fa-money",
    title: "Financial"
  }, {
    name: "airtime",
    icon: "fa fa-university",
    title: "Airtime"
  }, {
    name: "monnify",
    icon: "widgets",
    title: "Monnify"
  }]
}, {
  icon: "fa fa-university",
  group: "cashin",
  title: "Cash",
  items: [{
    name: "bank",
    icon: "fa fa-university",
    title: "Bank"
  }, {
    name: "cashin",
    icon: "fa fa-money",
    title: "Cash In"
  }, {
    name: "online-bank-reconcilate",
    icon: "fa fa-exclamation-circle",
    title: "Online Bank"
  }]
}, {
  icon: "fa fa-wrench",
  title: "Admin Tools",
  group: "admin_tools",
  items: [
  // {
  //   name: "edit_menu",
  //   icon: "fa fa-edit",
  //   title: "Edit Menu"
  // },
  {
    name: "get_sms_code",
    icon: "fa fa-wrench",
    title: "SMS Code"
  },
  // {
  //   name: "change_roles",
  //   icon: "fa fa-edit",
  //   title: "Change Role"
  // },
  // {
  //   name: "edit_permissions",
  //   icon: "fa fa-edit",
  //   title: "Edit permissions"
  // },
  {
    name: "password_change",
    icon: "fa fa-edit",
    title: "Change password"
  }, { name: "staff", icon: "fa fa-users", title: "Staff" }, { name: "permissions", icon: "fa fa-key", title: "Permissions" }]
}, {
  icon: "fa fa-wrench",
  title: "Provider",
  group: "provider",
  items: [{
    name: "list",
    icon: "fa fa-money",
    title: "Providers"
  }, {
    name: "balances",
    icon: "fa fa-money",
    title: "Providers Balances"
  }, {
    name: "commissions",
    icon: "fa fa-money",
    title: "Commissions"
  }]
}, {
  icon: "fa fa-line-chart",
  title: "Charts",
  group: "chart",
  items: [{
    name: "agent_transactions_and_tua_profit_dynamics",
    icon: "fa fa-line-chart",
    title: "Agent transactions and TUA profit dynamics"
  }, {
    name: "sales_and_profit_by_providers",
    icon: "fa fa-line-chart",
    title: "Sales and profit by providers"
  }, {
    name: "sales_and_profit_dynamics_by_providers",
    icon: "fa fa-line-chart",
    title: "Sales and profit dynamics by providers"
  }, {
    name: "sales_and_agents_deposites_dynamic",
    icon: "fa fa-line-chart",
    title: "Sales and agents deposites dynamic"
  }, {
    name: "agents_deposits_and_profit_balance",
    icon: "fa fa-line-chart",
    title: "Agents deposits and profit balance"
  }, {
    name: "number_of_tua_accounts",
    icon: "fa fa-line-chart",
    title: "Number of TUA accounts"
  }, {
    name: "sales_by_airtime_credit",
    icon: "fa fa-line-chart",
    title: "Airtime credited by Banks/Cash"
  }, {
    name: "agents_sales",
    icon: "fa fa-line-chart",
    title: "Agents sales"
  }, {
    name: "monthly_total_sales",
    icon: "fa fa-line-chart",
    title: "Monthly total sales"
  }, {
    name: "monthly_average",
    icon: "fa fa-line-chart",
    title: "Monthly Average"
  }, {
    name: "users_and_referals",
    icon: "fa fa-line-chart",
    title: "Users And Referals"
  }, {
    name: "general",
    icon: "fa fa-line-chart",
    title: "General Report"
  }]
  // {
  //   icon: "fa fa-users",
  //   title: "Agents Network",
  //   group: "vendors",
  //   items: [
  //     {
  //       name: "new-vendor",
  //       icon: "fa fa-user",
  //       title: "Fill Form",
  //     },
  //     {
  //       name: "vendors",
  //       icon: "fa fa-user",
  //       title: "Vendors",
  //     }
  //   ]
  // }
}];
// reorder menu
// Menu.forEach(item => {
//   if (item.items) {
//   }
// });

/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'APP_LOGIN_SUCCESS',
  callback: function callback(e) {
    this.$router.push({ path: 'dashboard' });
  }
}, {
  name: 'APP_LOGOUT',
  callback: function callback(e) {
    this.snackbar = {
      show: true,
      color: 'green',
      text: 'Logout successfully.'
    };
    this.$router.replace({ path: '/login' });
  }
}, {
  name: 'APP_PAGE_LOADED',
  callback: function callback(e) {}
}, {
  name: 'APP_ABILITIES_UPDATE',
  callback: function callback(e) {
    console.log("abilities update called");
  }
}, {
  name: 'APP_AUTH_FAILED',
  callback: function callback(e) {
    this.$router.push('/login');
    this.$message.error('Token has expired');
  }
}, {
  name: 'APP_BAD_REQUEST',
  // @error api response data
  callback: function callback(msg) {
    this.$message.error(msg);
  }
}, {
  name: 'APP_ACCESS_DENIED',
  // @error api response data
  callback: function callback(msg) {
    this.$message.error(msg);
    this.$router.push('/forbidden');
  }
}, {
  name: 'APP_RESOURCE_DELETED',
  // @error api response data
  callback: function callback(msg) {
    this.$message.success(msg);
  }
}, {
  name: 'APP_RESOURCE_UPDATED',
  // @error api response data
  callback: function callback(msg) {
    this.$message.success(msg);
  }
}]);

/***/ }),

/***/ 418:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__helpers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__helpers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_ability__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__casl_vue__ = __webpack_require__(378);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












var toastrConfigs = {
  position: 'top right',
  showDuration: 1000,
  timeOut: 5000,
  progressBar: true,
  showMethod: 'fadeInUp',
  hideMethod: 'fadeOutDown'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10__casl_vue__["a" /* abilitiesPlugin */], __WEBPACK_IMPORTED_MODULE_9__config_ability__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, {
  iconfont: 'mdi'
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr___default.a, toastrConfigs);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyA92fLXWQSL1z3lVh3iz76KRPP6E7TAyBk',
    libraries: 'places'
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].beforeEach(function (to, from, next) {
  console.log(from, to);
  next();
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('filter', function (value, format) {
  switch (format) {
    case 'currency':
      {
        var formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2 /* this might not be necessary */
        });
        return formatter.format(value);
      }

    default:
      return value;
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('currency', function (value) {
  var formatter = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2 /* this might not be necessary */
  });
  return formatter.format(value);
});

/* eslint-disable no-new */
__WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit("clearLoading");
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  //mixins: [loaderMixin],
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App___default.a }
});

/***/ }),

/***/ 419:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/admin_tools",
  name: "admin_tools",
  component: {
    template: "<router-view></router-view>"
  },
  children: [{
    path: "change_roles",
    name: "admin_tools/change_roles",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(41).then((function (require) {
          resolve(__webpack_require__(715));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::role"
    }
  }, {
    path: "get_sms_code",
    name: "admin_tools/get_sms_code",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(40).then((function (require) {
          resolve(__webpack_require__(718));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::admin-tools:get-sms-code"
    }
  }, {
    path: "edit_menu",
    name: "admin_tools/edit_menu",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(22).then((function (require) {
          resolve(__webpack_require__(716));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::menu"
    }
  }, {
    path: "edit_permissions",
    name: "admin_tools/edit_permissions",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(26).then((function (require) {
          resolve(__webpack_require__(717));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::role:permissions"
    }
  }, {
    path: "password_change",
    name: "admin_tools/password_change",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(39).then((function (require) {
          resolve(__webpack_require__(719));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::customer:password"
    }
  }, {
    path: "staff",
    name: "admin_tools/staff",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(21).then((function (require) {
          resolve(__webpack_require__(720));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::admin-tools:staff"
    }
  }, {
    path: "permissions",
    name: "admin_tools/permissions",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(27).then((function (require) {
          resolve(__webpack_require__(714));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::admin-tools:permissions"
    }
  }]
});

/***/ }),

/***/ 420:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/cashin",
  name: "cashin",
  component: {
    template: "<router-view></router-view>"
  },
  children: [
  //
  {
    path: "cashin",
    name: "cashin/cashin",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(37).then((function (require) {
          resolve(__webpack_require__(713));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::main:cash-in"
    }
  }, {
    path: "bank",
    name: "cashin/bank",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(38).then((function (require) {
          resolve(__webpack_require__(712));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::main:cash-in-bank"
    }
  }, {
    path: "online-bank-reconcilate",
    name: "cashin/online-bank-reconcilate",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(36).then((function (require) {
          resolve(__webpack_require__(721));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::main:cash-in-online"
    }
  }]
});

/***/ }),

/***/ 421:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/chart",
  name: "chart",
  component: {
    template: "<router-view></router-view>"
  },
  children: [{
    path: "general",
    name: "chart/general",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(23).then((function (require) {
          resolve(__webpack_require__(726));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:general-report"
    }
  }, {
    path: "agent_transactions_and_tua_profit_dynamics",
    name: "chart/agent_transactions_and_tua_profit_dynamics",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(17).then((function (require) {
          resolve(__webpack_require__(722));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:agent-transactions-and-tua-profit-dynamics"
    }
  }, {
    path: "sales_and_profit_by_providers",
    name: "chart/sales_and_profit_by_providers",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(10).then((function (require) {
          resolve(__webpack_require__(731));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:sales-and-profit-by-providers"
    }
  }, {
    path: "sales_and_profit_dynamics_by_providers",
    name: "chart/sales_and_profit_dynamics_by_providers",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(9).then((function (require) {
          resolve(__webpack_require__(732));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:sales-and-profit-dynamics-by-providers"
    }
  }, {
    path: "sales_and_agents_deposites_dynamic",
    name: "chart/sales_and_agents_deposites_dynamic",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(11).then((function (require) {
          resolve(__webpack_require__(730));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:sales-and-agents-deposites-dynamic"
    }
  }, {
    path: "agents_deposits_and_profit_balance",
    name: "chart/agents_deposits_and_profit_balance",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(16).then((function (require) {
          resolve(__webpack_require__(723));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:agents-deposits-and-profit-balance"
    }
  }, {
    path: "sales_by_airtime_credit",
    name: "chart/sales_by_airtime_credit",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(8).then((function (require) {
          resolve(__webpack_require__(733));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:sales-by-airtime-credit"
    }
  }, {
    path: "number_of_tua_accounts",
    name: "chart/number_of_tua_accounts",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(12).then((function (require) {
          resolve(__webpack_require__(729));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:number-of-tua-accounts"
    }
  }, {
    path: "monthly_total_sales",
    name: "chart/monthly_total_sales",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(13).then((function (require) {
          resolve(__webpack_require__(728));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:monthly-total-sales"
    }
  }, {
    path: "monthly_average",
    name: "chart/monthly_average",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(14).then((function (require) {
          resolve(__webpack_require__(727));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:monthly-average-report"
    }
  }, {
    path: "agents_sales",
    name: "chart/agents_sales",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(15).then((function (require) {
          resolve(__webpack_require__(724));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:agents-sales"
    }
  }, {
    path: "users_and_referals",
    name: "chart/users_and_referals",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(7).then((function (require) {
          resolve(__webpack_require__(734));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:users-and-referals"
    }
  }, {
    path: "company-assets",
    name: "chart/company-assets",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(35).then((function (require) {
          resolve(__webpack_require__(725));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::chart:company-assets"
    }
  }]
});

/***/ }),

/***/ 422:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/partner",
  component: {
    template: "<router-view></router-view>"
  },
  children: [{
    path: "users",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(24).then((function (require) {
          resolve(__webpack_require__(741));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: "add-user",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(32).then((function (require) {
          resolve(__webpack_require__(739));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: "report",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(20).then((function (require) {
          resolve(__webpack_require__(740));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }]
});

/***/ }),

/***/ 423:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/provider",
  name: "provider",
  component: { template: "<router-view/>" },
  children: [{
    path: "commissions",
    name: "provider/commissions",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(30).then((function (require) {
          resolve(__webpack_require__(743));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::provider:commissions"
    }
  }, {
    path: "balances",
    name: "provider/balances",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(31).then((function (require) {
          resolve(__webpack_require__(742));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::provider:balances"
    }
  }, {
    path: "list",
    name: "provider/list",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(29).then((function (require) {
          resolve(__webpack_require__(744));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::provider:list"
    }
  }]
});

/***/ }),

/***/ 424:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/report",
  name: "report",
  component: { template: "<router-view/>" },
  children: [{
    path: "technical/:provider?",
    name: "report/technical",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
          resolve(__webpack_require__(86));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      type: "technical"
    },
    meta: {
      can: "admin::report:technical"
    }
  }, {
    path: "financial/:provider?",
    name: "report/financial",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
          resolve(__webpack_require__(86));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      type: "financial"
    },
    meta: {
      can: "admin::report:financial"
    }
  }, {
    path: "transfers/:provider?",
    name: "report/transfers",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
          resolve(__webpack_require__(86));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      type: "transfers"
    },
    meta: {
      can: "admin::report:transfers"
    }
  }, {
    path: "airtime/:provider?",
    name: "report/airtime",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(0/* duplicate */).then((function (require) {
          resolve(__webpack_require__(86));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      type: "airtime"
    },
    meta: {
      can: "admin::report:airtime"
    }
  }, {
    path: "queue",
    name: "report/queue",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(5).then((function (require) {
          resolve(__webpack_require__(746));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::report:queue"
    }
  }, {
    path: "vouchers",
    name: "report/vouchers",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(19).then((function (require) {
          resolve(__webpack_require__(747));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::report:vouchers"
    }
  }, {
    path: "monnify",
    name: "report/monnify",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(18).then((function (require) {
          resolve(__webpack_require__(745));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: "admin::report:monnify"
    }
  }],
  meta: {
    can: "admin::report"
  }
});

/***/ }),

/***/ 425:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

/* harmony default export */ __webpack_exports__["a"] = ({
  path: "/vendors",
  component: { template: "<router-view/>" },
  children: [{
    path: "vendors",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(4).then((function (require) {
          resolve(__webpack_require__(750));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  },
  // {
  //   path: 'vendors-map',
  //   component: () => import('@/components/Vendors/VendorsMap')
  // },
  {
    path: "new-vendor",
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(6).then((function (require) {
          resolve(__webpack_require__(749));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }]
});

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "login", function() { return login; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "activate", function() { return activate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirm", function() { return confirm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "logout", function() { return logout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkAuth", function() { return checkAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(18);





var login = function login(_ref, body) {
  var commit = _ref.commit,
      dispatch = _ref.dispatch;

  commit('setError', '');
  __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/auth/login', body).then(function (response) {
    if (response.status == 201) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: 'login-activate',
        params: {
          Login: body.Login,
          Password: body.Password,
          Secret: response.data.data.Secret,
          Sign: response.data.data.Sign,
          Message: response.data.message
        }
      });
    } else if (response.status === 200) {
      Activate({ commit: commit, dispatch: dispatch }, body, response);
      console.log(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    } else if (response.status === 202) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: 'login-confirm',
        params: {
          Login: body.Login,
          Password: body.Password
        }
      });
    } else {
      commit('setError', response.data.message);
    }
  });
};

var activate = function activate(_ref2, body) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch;

  commit('setError', '');
  console.log(body);
  return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/auth/login/activate', body).then(function (response) {
    if (response.status == 201) {
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({
        name: 'login-confirm',
        params: {
          Login: body.Login,
          Password: body.Password
        }
      });
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve('Successful');
    } else if (response.status == 200) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(response.data.message);
    } else {
      commit('setError', response.data.message);
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(response.data.message);
    }
  });
};
function Activate(_ref3, body, response) {
  var commit = _ref3.commit,
      dispatch = _ref3.dispatch;

  commit('setToken', response.data.data.Token);
  commit('setPermissions', response.data.data.Permissions);
  commit('setLogin', body.Login);
  commit('setRole', response.data.data.Roles);
  commit('setAuthenticated', true);
  commit('setExpiredAt', new Date(response.data.data.ExpiredAt));
  commit('setAbilities', response.data.data.Token);
}
var confirm = function confirm(_ref4, body) {
  var commit = _ref4.commit,
      dispatch = _ref4.dispatch;

  commit('setError', '');
  __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post('/auth/login/confirm', body).then(function (response) {
    if (response.status === 200) {
      Activate({ commit: commit, dispatch: dispatch }, body, response);
      console.log(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/');
    } else {
      commit('setAuthenticated', false);
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
    }
  }).catch(function (err) {
    console.log(err);
    commit('setAuthenticated', false);
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
  });
};

var logout = function logout(_ref5) {
  var state = _ref5.state,
      commit = _ref5.commit,
      dispatch = _ref5.dispatch;

  commit('setToken', null);
  commit('setPermissions', []);
  commit('setLogin', null);
  commit('setRole', null);
  commit('setAuthenticated', false);
  commit('setExpiredAt', null);
  commit('setAbilities', null);
  __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
};

var checkAuth = function checkAuth(_ref6) {
  var state = _ref6.state,
      commit = _ref6.commit,
      dispatch = _ref6.dispatch;

  if (state.tokenExpire && new Date(state.tokenExpire) < new Date()) {
    return dispatch('logout');
  } else {
    return;
  }
};

/***/ }),

/***/ 427:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api__ = __webpack_require__(18);




var _actions;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: (_actions = {
    smsCodeGet: function smsCodeGet(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/admin-tools/get-sms-code", body);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "search-sms-user", function searchSmsUser(_ref2, login) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/search-sms-user/" + login);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "permissionsGet", function permissionsGet(_ref3, body) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/Role/Permissions", body);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "accessChange", function accessChange(_ref4, body) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/Role/ChangeAccess", body);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "userRolesGet", function userRolesGet(_ref5, body) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/admin-tools/roles", body);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "rolesGet", function rolesGet() {
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/roles");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "roleChange", function roleChange(_ref6, body) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/admin-tools/role", body);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "staffGet", function staffGet(_ref7) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/staff");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "staff/delete", function staffDelete(_ref8, _ref9) {
    var UserGuid = _ref9.UserGuid;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].delete("/admin-tools/staff/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "staff/add", function staffAdd(_ref10, _ref11) {
    var UserGuid = _ref11.UserGuid,
        roleIds = _ref11.roleIds;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref10);

    console.log(roleIds);
    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].put("/admin-tools/staff/" + UserGuid, {
      RolesId: roleIds.map(function (item) {
        return item;
      })
    });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "staff/get", function staffGet(_ref12, _ref13) {
    var UserGuid = _ref13.UserGuid;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref12);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/staff/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "permissionsGetNew", function permissionsGetNew(_ref14) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref14);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/permissions");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "rolesGetNew", function rolesGetNew(_ref15) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref15);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/roles");
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "rolePermissionsGet", function rolePermissionsGet(_ref16, RoleId) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref16);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].get("/admin-tools/permission/" + RoleId);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "rolePermissionsSet", function rolePermissionsSet(_ref18, _ref17) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref18);

    var RoleId = _ref17.RoleId,
        body = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref17, ["RoleId"]);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].post("/admin-tools/permission/" + RoleId, body);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "setPassword", function setPassword(_ref19, _ref20) {
    var UserGuid = _ref20.User.UserGuid,
        Password = _ref20.Password;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref19);

    return __WEBPACK_IMPORTED_MODULE_3__api__["a" /* default */].put("/customer/password/" + UserGuid, { Password: Password });
  }), _actions)
});

/***/ }),

/***/ 428:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    //   //Charts
    getGeneralReport: function getGeneralReport(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/GeneralReport", body);
    },
    getAgentTransactionsAndTuaProfitDynamics: function getAgentTransactionsAndTuaProfitDynamics(_ref2, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/AgentTransactionsAndTuaProfitDynamics", body);
    },
    getSalesAndProfitByProviders: function getSalesAndProfitByProviders(_ref3, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/SalesAndProfitByProviders", body);
    },
    getSalesAndProfitDynamicsByProviders: function getSalesAndProfitDynamicsByProviders(_ref4, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/SalesAndProfitDynamicsByProviders", body);
    },
    getSalesAndAgentsDepositesDynamic: function getSalesAndAgentsDepositesDynamic(_ref5, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/SalesAndAgentsDepositesDynamic", body);
    },
    getAgentsDepositsAndProfitBalance: function getAgentsDepositsAndProfitBalance(_ref6, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/AgentsDepositsAndProfitBalance", body);
    },
    getSalesByAirtimeCredit: function getSalesByAirtimeCredit(_ref7, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/SalesByAirtimeCredit", body);
    },
    getNumberOfTUAAccounts: function getNumberOfTUAAccounts(_ref8, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/NumberOfTUAAccounts", body);
    },
    getMonthlyTotalSales: function getMonthlyTotalSales(_ref9, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/MonthlyTotalSales", body);
    },
    getMonthlyAverageReport: function getMonthlyAverageReport(_ref10, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref10);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/MonthlyAverageReport", body);
    },
    getAgentsSales: function getAgentsSales(_ref11, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref11);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/AgentsSales", body);
    },
    getUsersAndReferals: function getUsersAndReferals(_ref12, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref12);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/UsersAndReferals", body);
    },
    getTransactionsByUsersAndReferals: function getTransactionsByUsersAndReferals(_ref13, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref13);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/chart/TransactionsByUsersAndReferals", body);
    }
  }
});

/***/ }),

/***/ 429:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    getUsers: function getUsers(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/customer/list", body);
    },
    getNewUsersCount: function getNewUsersCount(_ref2) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/customer/count-new");
    }
  }
});

/***/ }),

/***/ 430:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    getPartnerUsers: function getPartnerUsers(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/partner/users", body);
    },
    getPartnerUsersCount: function getPartnerUsersCount(_ref2) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/partner/users/count");
    },
    validateUser: function validateUser(_ref3, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/partner/user/find", body);
    },
    confirmUser: function confirmUser(_ref4, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/partner/user/confirm", body);
    },
    technicalReport: function technicalReport(_ref5, body) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].post("/partner/report/technical", body);
    }
  }
});

/***/ }),

/***/ 431:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(18);



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    getBalances: function getBalances() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/Provider/Balances");
    },
    getCommissions: function getCommissions() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/Provider/Commissions");
    },
    getProviders: function getProviders() {
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/Provider/List");
    },
    checkMonnify: function checkMonnify(_ref, reference) {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      console.log(reference);
      return __WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */].get("/Provider/check-monnify/" + reference);
    }
  }
});

/***/ }),

/***/ 432:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(18);




/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: {
    technical: function technical(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/technical", body);
    },
    airtime: function airtime(_ref2, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/airtime", body);
    },
    transfers: function transfers(_ref3, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/transfers", body);
    },
    financial: function financial(_ref4, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/financial", body);
    },
    getTransactionLog: function getTransactionLog(_ref5, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/log", body);
    },


    ////QUEUE
    queue: function queue(_ref6, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/report/queue", body);
    },
    getTransactionStates: function getTransactionStates() {
      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/report/queue/states");
    },
    changeTransactionStateFromHistory: function changeTransactionStateFromHistory(_ref7, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put("/report/history", body);
    },
    updateTransactionFromQueue: function updateTransactionFromQueue(_ref9, _ref8) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

      var Id = _ref8.Id,
          body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref8, ["Id"]);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put("/report/queue/" + Id, body);
    },
    deleteTransactionFromQueue: function deleteTransactionFromQueue(_ref10, _ref11) {
      var Id = _ref11.Id;

      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref10);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete("/report/queue/" + Id);
    },
    getListOfTransaction: function getListOfTransaction(_ref12, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref12);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post('/report/getalltransaction', body);
    },
    getAllStates: function getAllStates(_ref13, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref13);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get('/report/queue/states');
    },


    // Bulk operations (only for queue)
    bulkUpdateQueue: function bulkUpdateQueue(_ref14, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref14);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].put('/report/queue/bulk', body);
    },
    bulkDeleteQueue: function bulkDeleteQueue(_ref15, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref15);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post('/report/queue/bulk-delete', body);
    }
  }
});

/***/ }),

/***/ 433:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(18);



var _actions;



/* harmony default export */ __webpack_exports__["a"] = ({
  namespaced: true,
  actions: (_actions = {
    usersGet: function usersGet(_ref, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/list", body);
    },
    usersKycGet: function usersKycGet(_ref2, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref2);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/kyc/list", body);
    },
    usersKycVerifiedGet: function usersKycVerifiedGet(_ref3, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref3);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/kyc/list/verified", body);
    },
    usersKycRejectedGet: function usersKycRejectedGet(_ref4, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref4);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/kyc/list/rejected", body);
    },
    lastHistoryGet: function lastHistoryGet(_ref5, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref5);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/history/last", body);
    },
    cashInHistoryGet: function cashInHistoryGet(_ref6, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref6);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/history/cash-in", body);
    },
    cashIn: function cashIn(_ref7, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref7);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/main/cash-in", body);
    },
    cashInBank: function cashInBank(_ref8, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref8);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/main/cash-in-bank", body);
    },
    cashInOnline: function cashInOnline(_ref9, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref9);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/main/cash-in-online", body);
    },
    userFind: function userFind(_ref10, body) {
      __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref10);

      return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/customer/find?login=" + body);
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "customer/get", function customerGet(_ref11, _ref12) {
    var UserGuid = _ref12.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref11);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/customer/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "getLock", function getLock(_ref13, _ref14) {
    var UserGuid = _ref14.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref13);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/customer/lock/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "setLock", function setLock(_ref15, _ref16) {
    var UserGuid = _ref16.UserGuid,
        Reason = _ref16.Reason;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref15);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/lock/" + UserGuid, { Reason: Reason });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "deleteLock", function deleteLock(_ref17, _ref18) {
    var UserGuid = _ref18.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref17);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].delete("/customer/lock/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "getKyc", function getKyc(_ref19, _ref20) {
    var UserGuid = _ref20.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref19);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/customer/kyc/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "getLevel", function getLevel(_ref21, _ref22) {
    var UserGuid = _ref22.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref21);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].get("/customer/level/" + UserGuid);
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "setKycStatus", function setKycStatus(_ref23, _ref24) {
    var UserGuid = _ref24.UserGuid,
        Status = _ref24.Status,
        Id = _ref24.Id,
        Reason = _ref24.Reason;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref23);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/kyc/" + UserGuid, { Status: Status, Id: Id, Reason: Reason });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "setUserLevel", function setUserLevel(_ref25, _ref26) {
    var UserGuid = _ref26.UserGuid,
        Level = _ref26.Level;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref25);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/level/" + UserGuid, { Level: Level });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "sendNotification", function sendNotification(_ref27, _ref28) {
    var Message = _ref28.Message,
        UserGuid = _ref28.UserGuid;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref27);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/notification/" + UserGuid, { Message: Message });
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, "sendNotificationToAll", function sendNotificationToAll(_ref29, _ref30) {
    var Message = _ref30.Message;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectDestructuringEmpty___default()(_ref29);

    return __WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */].post("/customer/notification/", { Message: Message });
  }), _actions)
});

/***/ }),

/***/ 434:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLogin", function() { return setLogin; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setRole", function() { return setRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPermissions", function() { return setPermissions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setUserGuid", function() { return setUserGuid; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setToken", function() { return setToken; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setExpiredAt", function() { return setExpiredAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAuthenticated", function() { return setAuthenticated; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clearLoading", function() { return clearLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLoading", function() { return setLoading; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setError", function() { return setError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setOnlineStaff", function() { return setOnlineStaff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setTransactionsQueue", function() { return setTransactionsQueue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAbilities", function() { return setAbilities; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jsonwebtoken___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casl_ability_extra__ = __webpack_require__(401);



var setLogin = function setLogin(state, data) {
  state.login = data;
};
var setRole = function setRole(state, data) {
  state.role = data;
};
var setPermissions = function setPermissions(state, data) {
  state.permissions = data;
};
var setUserGuid = function setUserGuid(state, data) {
  state.userGuid = data;
};
var setToken = function setToken(state, data) {
  state.token = data;
};
var setExpiredAt = function setExpiredAt(state, data) {
  state.tokenExpire = data;
};
var setAuthenticated = function setAuthenticated(state, data) {
  state.authenticated = data;
};
var clearLoading = function clearLoading(state, data) {
  state.requests = 0;
  state.loading = !!state.requests;
};
var setLoading = function setLoading(state, data) {
  if (data) state.requests++;else if (state.requests > 0) state.requests--;
  state.loading = !!state.requests;
};

var setError = function setError(state, data) {
  state.error = data;
};

var setOnlineStaff = function setOnlineStaff(state, data) {
  state.onlineStaff = data;
};
var setTransactionsQueue = function setTransactionsQueue(state, data) {
  state.transactionsQueue = data;
};

var setAbilities = function setAbilities(state, data) {
  if (data) {
    var jwt = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_jsonwebtoken__["decode"])(data);
    state.abilities = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__casl_ability_extra__["a" /* unpackRules */])(jwt.rules);
  } else {
    state.abilities = state.degaultRules;
  }
};

/***/ }),

/***/ 489:
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),

/***/ 502:
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),

/***/ 503:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 504:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 505:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 218,
	"./af.js": 218,
	"./ar": 226,
	"./ar-dz": 219,
	"./ar-dz.js": 219,
	"./ar-kw": 220,
	"./ar-kw.js": 220,
	"./ar-ly": 221,
	"./ar-ly.js": 221,
	"./ar-ma": 222,
	"./ar-ma.js": 222,
	"./ar-ps": 223,
	"./ar-ps.js": 223,
	"./ar-sa": 224,
	"./ar-sa.js": 224,
	"./ar-tn": 225,
	"./ar-tn.js": 225,
	"./ar.js": 226,
	"./az": 227,
	"./az.js": 227,
	"./be": 228,
	"./be.js": 228,
	"./bg": 229,
	"./bg.js": 229,
	"./bm": 230,
	"./bm.js": 230,
	"./bn": 232,
	"./bn-bd": 231,
	"./bn-bd.js": 231,
	"./bn.js": 232,
	"./bo": 233,
	"./bo.js": 233,
	"./br": 234,
	"./br.js": 234,
	"./bs": 235,
	"./bs.js": 235,
	"./ca": 236,
	"./ca.js": 236,
	"./cs": 237,
	"./cs.js": 237,
	"./cv": 238,
	"./cv.js": 238,
	"./cy": 239,
	"./cy.js": 239,
	"./da": 240,
	"./da.js": 240,
	"./de": 243,
	"./de-at": 241,
	"./de-at.js": 241,
	"./de-ch": 242,
	"./de-ch.js": 242,
	"./de.js": 243,
	"./dv": 244,
	"./dv.js": 244,
	"./el": 245,
	"./el.js": 245,
	"./en-au": 246,
	"./en-au.js": 246,
	"./en-ca": 247,
	"./en-ca.js": 247,
	"./en-gb": 248,
	"./en-gb.js": 248,
	"./en-ie": 249,
	"./en-ie.js": 249,
	"./en-il": 250,
	"./en-il.js": 250,
	"./en-in": 251,
	"./en-in.js": 251,
	"./en-nz": 252,
	"./en-nz.js": 252,
	"./en-sg": 253,
	"./en-sg.js": 253,
	"./eo": 254,
	"./eo.js": 254,
	"./es": 258,
	"./es-do": 255,
	"./es-do.js": 255,
	"./es-mx": 256,
	"./es-mx.js": 256,
	"./es-us": 257,
	"./es-us.js": 257,
	"./es.js": 258,
	"./et": 259,
	"./et.js": 259,
	"./eu": 260,
	"./eu.js": 260,
	"./fa": 261,
	"./fa.js": 261,
	"./fi": 262,
	"./fi.js": 262,
	"./fil": 263,
	"./fil.js": 263,
	"./fo": 264,
	"./fo.js": 264,
	"./fr": 267,
	"./fr-ca": 265,
	"./fr-ca.js": 265,
	"./fr-ch": 266,
	"./fr-ch.js": 266,
	"./fr.js": 267,
	"./fy": 268,
	"./fy.js": 268,
	"./ga": 269,
	"./ga.js": 269,
	"./gd": 270,
	"./gd.js": 270,
	"./gl": 271,
	"./gl.js": 271,
	"./gom-deva": 272,
	"./gom-deva.js": 272,
	"./gom-latn": 273,
	"./gom-latn.js": 273,
	"./gu": 274,
	"./gu.js": 274,
	"./he": 275,
	"./he.js": 275,
	"./hi": 276,
	"./hi.js": 276,
	"./hr": 277,
	"./hr.js": 277,
	"./hu": 278,
	"./hu.js": 278,
	"./hy-am": 279,
	"./hy-am.js": 279,
	"./id": 280,
	"./id.js": 280,
	"./is": 281,
	"./is.js": 281,
	"./it": 283,
	"./it-ch": 282,
	"./it-ch.js": 282,
	"./it.js": 283,
	"./ja": 284,
	"./ja.js": 284,
	"./jv": 285,
	"./jv.js": 285,
	"./ka": 286,
	"./ka.js": 286,
	"./kk": 287,
	"./kk.js": 287,
	"./km": 288,
	"./km.js": 288,
	"./kn": 289,
	"./kn.js": 289,
	"./ko": 290,
	"./ko.js": 290,
	"./ku": 292,
	"./ku-kmr": 291,
	"./ku-kmr.js": 291,
	"./ku.js": 292,
	"./ky": 293,
	"./ky.js": 293,
	"./lb": 294,
	"./lb.js": 294,
	"./lo": 295,
	"./lo.js": 295,
	"./lt": 296,
	"./lt.js": 296,
	"./lv": 297,
	"./lv.js": 297,
	"./me": 298,
	"./me.js": 298,
	"./mi": 299,
	"./mi.js": 299,
	"./mk": 300,
	"./mk.js": 300,
	"./ml": 301,
	"./ml.js": 301,
	"./mn": 302,
	"./mn.js": 302,
	"./mr": 303,
	"./mr.js": 303,
	"./ms": 305,
	"./ms-my": 304,
	"./ms-my.js": 304,
	"./ms.js": 305,
	"./mt": 306,
	"./mt.js": 306,
	"./my": 307,
	"./my.js": 307,
	"./nb": 308,
	"./nb.js": 308,
	"./ne": 309,
	"./ne.js": 309,
	"./nl": 311,
	"./nl-be": 310,
	"./nl-be.js": 310,
	"./nl.js": 311,
	"./nn": 312,
	"./nn.js": 312,
	"./oc-lnc": 313,
	"./oc-lnc.js": 313,
	"./pa-in": 314,
	"./pa-in.js": 314,
	"./pl": 315,
	"./pl.js": 315,
	"./pt": 317,
	"./pt-br": 316,
	"./pt-br.js": 316,
	"./pt.js": 317,
	"./ro": 318,
	"./ro.js": 318,
	"./ru": 319,
	"./ru.js": 319,
	"./sd": 320,
	"./sd.js": 320,
	"./se": 321,
	"./se.js": 321,
	"./si": 322,
	"./si.js": 322,
	"./sk": 323,
	"./sk.js": 323,
	"./sl": 324,
	"./sl.js": 324,
	"./sq": 325,
	"./sq.js": 325,
	"./sr": 327,
	"./sr-cyrl": 326,
	"./sr-cyrl.js": 326,
	"./sr.js": 327,
	"./ss": 328,
	"./ss.js": 328,
	"./sv": 329,
	"./sv.js": 329,
	"./sw": 330,
	"./sw.js": 330,
	"./ta": 331,
	"./ta.js": 331,
	"./te": 332,
	"./te.js": 332,
	"./tet": 333,
	"./tet.js": 333,
	"./tg": 334,
	"./tg.js": 334,
	"./th": 335,
	"./th.js": 335,
	"./tk": 336,
	"./tk.js": 336,
	"./tl-ph": 337,
	"./tl-ph.js": 337,
	"./tlh": 338,
	"./tlh.js": 338,
	"./tr": 339,
	"./tr.js": 339,
	"./tzl": 340,
	"./tzl.js": 340,
	"./tzm": 342,
	"./tzm-latn": 341,
	"./tzm-latn.js": 341,
	"./tzm.js": 342,
	"./ug-cn": 343,
	"./ug-cn.js": 343,
	"./uk": 344,
	"./uk.js": 344,
	"./ur": 345,
	"./ur.js": 345,
	"./uz": 347,
	"./uz-latn": 346,
	"./uz-latn.js": 346,
	"./uz.js": 347,
	"./vi": 348,
	"./vi.js": 348,
	"./x-pseudo": 349,
	"./x-pseudo.js": 349,
	"./yo": 350,
	"./yo.js": 350,
	"./zh-cn": 351,
	"./zh-cn.js": 351,
	"./zh-hk": 352,
	"./zh-hk.js": 352,
	"./zh-mo": 353,
	"./zh-mo.js": 353,
	"./zh-tw": 354,
	"./zh-tw.js": 354
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 643;

/***/ }),

/***/ 645:
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(687),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(686),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(504)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(684),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(682),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(505)
}
var Component = __webpack_require__(35)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(685),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 682:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 683:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire",
      "standalone": ""
    }
  }, [(_vm.authenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "persistent": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "teal",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile-action', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.role))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.login))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "expand": ""
    }
  }, [_vm._l((_vm.menus), function(item, i) {
    return [(item.items) ? _c('v-list-group', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.menuCan(item)),
        expression: "menuCan(item)"
      }],
      key: item.name,
      attrs: {
        "group": item.group,
        "prepend-icon": item.icon,
        "no-action": "no-action"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "ripple": "ripple"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)], 1), _vm._v(" "), _vm._l((item.items), function(subItem, i) {
      return [(subItem.items) ? _c('v-list-group', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.menuCan(subItem, item.group)),
          expression: "menuCan(subItem, item.group)"
        }],
        key: subItem.name,
        attrs: {
          "group": subItem.group,
          "sub-group": "sub-group"
        }
      }, [_c('v-list-tile', {
        attrs: {
          "slot": "activator",
          "ripple": "ripple"
        },
        slot: "activator"
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(subItem.title))])], 1)], 1), _vm._v(" "), _vm._l((subItem.children), function(grand, i) {
        return _c('v-list-tile', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.menuCan(grand, subItem.group)),
            expression: "menuCan(grand, subItem.group)"
          }],
          key: i,
          attrs: {
            "to": _vm.genChildTarget(item, grand),
            "href": grand.href,
            "ripple": "ripple"
          }
        }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(grand.title))])], 1)], 1)
      })], 2) : _c('v-list-tile', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.menuCan(subItem, item.group)),
          expression: "menuCan(subItem, item.group)"
        }],
        key: i,
        attrs: {
          "to": _vm.genChildTarget(item, subItem),
          "href": subItem.href,
          "disabled": subItem.disabled,
          "target": subItem.target,
          "ripple": "ripple"
        }
      }, [(subItem.icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(subItem.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', [_vm._v(_vm._s(subItem.title))])])], 1), _vm._v(" "), (subItem.action) ? _c('v-list-tile-action', [_c('v-icon', {
        class: [subItem.actionClass || 'success--text']
      }, [_vm._v(_vm._s(subItem.action))])], 1) : _vm._e()], 1)]
    })], 2) : (item.header) ? _c('v-subheader', {
      key: i
    }, [_vm._v(_vm._s(item.header))]) : (item.divider) ? _c('v-divider', {
      key: i
    }) : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.menuCan(item)),
        expression: "menuCan(item)"
      }],
      key: item.name,
      attrs: {
        "to": !item.href ? {
          name: item.name
        } : null,
        "href": item.href,
        "ripple": "ripple",
        "disabled": item.disabled,
        "target": item.target,
        "rel": "noopener"
      }
    }, [(item.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1), _vm._v(" "), (item.subAction) ? _c('v-list-tile-action', [_c('v-icon', {
      staticClass: "success--text"
    }, [_vm._v(_vm._s(item.subAction))])], 1) : _vm._e()], 1)]
  })], 2)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": ""
    }
  }, [(_vm.authenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("TopUp Admin Panel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.screenWidth > 500) ? [(_vm.authenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Logout")]) : _vm._e()] : [(_vm.authenticated) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('v-icon', {
    attrs: {
      "color": "white"
    }
  }, [_vm._v("fa-sign-out")])], 1) : _vm._e()]], 2), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-xl": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view')], 1)], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "height": "auto",
      "inset": "",
      "color": "indigo darken-4"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": "",
      "white--text": "",
      "xs12": "",
      "body-2": ""
    }
  }, [_vm._v("\n        ©2018 —\n        "), _c('strong', [_vm._v("V:1.1.11 D:4:31 PM")])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 684:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 685:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 686:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 687:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 699:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 700:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 701:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 702:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 703:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 704:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 705:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 706:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 707:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 708:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 709:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__chart__ = __webpack_require__(421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__provider__ = __webpack_require__(423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__report__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cash_in__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__admin_tools__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__partner__ = __webpack_require__(422);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);









var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  // mode: "history",
  routes: [
  //Main
  {
    path: '/test',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(28).then((function (require) {
          resolve(__webpack_require__(748));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      title: 'Dashboard',
      breadcrumb: [{
        text: '<i class="ti-home"></i> Dashboard 1',
        href: '/'
      }]
    }
  }, {
    path: '/403',
    name: '403',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(25).then((function (require) {
          resolve(__webpack_require__(736));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/',
    name: 'dashboard',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(34).then((function (require) {
          resolve(__webpack_require__(735));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: 'admin::dashboard'
    }
  }, {
    path: '/main/users',
    name: 'main/users',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(3).then((function (require) {
          resolve(__webpack_require__(737));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    meta: {
      can: 'admin::customer:list'
    }
  }, {
    path: '/user/kyc',
    name: 'user/kyc',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(1).then((function (require) {
          resolve(__webpack_require__(146));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      Request: true,
      Rejected: false,
      Verified: false
    },
    meta: {
      can: 'admin::customer:kyc'
    }
  }, {
    path: '/user/kyc-verified',
    name: 'user/kyc-verified',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
          resolve(__webpack_require__(146));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      Verified: true,
      Rejected: false,
      Request: false
    },
    meta: {
      can: 'admin::customer:kyc-verified'
    }
  },, {
    path: '/user/kyc-rejected',
    name: 'user/kyc-rejected',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(1/* duplicate */).then((function (require) {
          resolve(__webpack_require__(146));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: {
      Rejected: true,
      Verified: false,
      Request: false
    },
    meta: {
      can: 'admin::customer:kyc-rejected'
    }
  },
  //Provider
  __WEBPACK_IMPORTED_MODULE_5__provider__["a" /* default */],
  //Reports
  __WEBPACK_IMPORTED_MODULE_6__report__["a" /* default */],
  //Vendors
  __WEBPACK_IMPORTED_MODULE_7__vendor__["a" /* default */],
  //CashIn
  __WEBPACK_IMPORTED_MODULE_8__cash_in__["a" /* default */],
  //Charts
  __WEBPACK_IMPORTED_MODULE_4__chart__["a" /* default */],
  //Admin Tools
  __WEBPACK_IMPORTED_MODULE_9__admin_tools__["a" /* default */],
  //Partner
  __WEBPACK_IMPORTED_MODULE_10__partner__["a" /* default */], {
    name: 'login',
    path: '/login',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(2).then((function (require) {
          resolve(__webpack_require__(145));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/login/activate',
    name: 'login-activate',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function (require) {
          resolve(__webpack_require__(145));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: function props(route) {
      return {
        Login: route.params.Login,
        Password: route.params.Password,
        Secret: route.params.Secret,
        Message: route.params.Message
      };
    }
  }, {
    name: 'login-confirm',
    path: '/login/confirm',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(2/* duplicate */).then((function (require) {
          resolve(__webpack_require__(145));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    },
    props: true
  },
  //Notifications
  {
    path: '/notification/notifications',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(33).then((function (require) {
          resolve(__webpack_require__(738));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }]
});

router.beforeEach(function (to, from, next) {
  var publicPages = ['/login', '/login/activate', '/login/confirm'];
  var authRequired = !publicPages.includes(to.path);
  __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].dispatch('checkAuth').then(function () {
    var authenticated = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].state.authenticated;
    if (authRequired && !authenticated) {
      return next('/login');
    }
    next();
  });
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ })

},[418]);


// WEBPACK FOOTER //
// static/js/app.3ecfe6cf98d823467011.js